import { ALGO_TYPES } from "src/components/Planner/planner/wizard-constants";

export let LIGHTS_WITH_MOTION_INCLUDED = [225, 226, 227, 228];

export let CONVENTIONAL_ITEMS = {
    Basic: { placeItemId: 1, algo: ALGO_TYPES.Serial }, // Basic socket
    WaterProtected: { placeItemId: 2, algo: ALGO_TYPES.Serial }, // Water protected socket
    TelephoneData: { placeItemId: 5, algo: ALGO_TYPES.Serial }, // Tel/Data connection
    NetworkDouble: { placeItemId: 11, algo: ALGO_TYPES.Serial }, // Network connection
    Lighting: { placeItemId: 197, algo: ALGO_TYPES.Lighting }, // Conv. switched lighting
    LightSwitch: { placeItemId: 368, algo: ALGO_TYPES.Door },
    LightSwitchWet: { placeItemId: 17, algo: ALGO_TYPES.Door },
    DimmedLighting: { placeItemId: 303, algo: ALGO_TYPES.Lighting }, // Conv. dimmed lighting
    Shading: { placeItemId: 296, algo: ALGO_TYPES.Window },
    ShadingSwitch: { placeItemId: 322, algo: ALGO_TYPES.Door },
};

export let DIN_UPLAN_PRODUCT_MAPPING = {
    SteckdosenAllgemein_1: CONVENTIONAL_ITEMS.Basic, // Basic socket - Converted to WaterProtected in Wet rooms
    Beleuchtungsanschlusse_2: CONVENTIONAL_ITEMS.Lighting, // Lighting
    TelefonDatenanschlusseIuK_3: CONVENTIONAL_ITEMS.NetworkDouble, // Tel/Data
    SteckdosenFurIuK_4: CONVENTIONAL_ITEMS.Basic, // Socket for Tel/Data - Converted to WaterProtected in Wet rooms
    RadioTVDatenanschlusseRuK_5: CONVENTIONAL_ITEMS.TelephoneData, // Radio/TV
    SteckdosenFurRuK_6: CONVENTIONAL_ITEMS.Basic, // Socket for Radio/TV - Converted to WaterProtected in Wet rooms
    SteckdosenFurKuhlGefriergerat_7: CONVENTIONAL_ITEMS.Basic, // Socket for fridge - Converted to WaterProtected in Wet rooms
    SteckdosenFurDunstabzug_8: CONVENTIONAL_ITEMS.Basic, // Socket for dehumidifier - Converted to WaterProtected in Wet rooms
    AnschlusseFurLufter_9: null, // Switch for ventilation - skipped for now
    AnschlusseFurRollladenantrieb_10: null, // Switch for shading motor - skipped for now
};

export let ROOM_TYPES = {
    LivingRoom: 1,
    Kitchen: 2,
    WorkingRoom: 3,
    Bedroom: 4,
    Corridor: 5,
    Central: 6,
    Bathroom: 7,
    Toilet: 8,
    Garage: 9,
    ETC: 10,
    TerraceOrBalcony: 11,
    Garden: 12,
};

export let DIN_ROOM_TYPES = {
    Wohnzimmer: 1,
    SchlafKinderGasteArbeitszimmerBuro: 2,
    Esszimmer: 3,
    Kochnische: 4,
    Kuche: 5,
    Hausarbeitsraum: 6,
    Bad: 7,
    WC: 8,
    Flur: 9,
    Freisitz: 10,
    Abstellraum: 11,
    KellerBodenraumGarage: 12,
    Hobbyraum: 13,
    Kellergang: 14,
};

export let DIN_UPLAN_ROOM_MAPPINGS = {
    [ROOM_TYPES.LivingRoom]: DIN_ROOM_TYPES.Wohnzimmer,
    [ROOM_TYPES.Kitchen]: DIN_ROOM_TYPES.Kuche,
    [ROOM_TYPES.WorkingRoom]: DIN_ROOM_TYPES.SchlafKinderGasteArbeitszimmerBuro,
    [ROOM_TYPES.Bedroom]: DIN_ROOM_TYPES.SchlafKinderGasteArbeitszimmerBuro,
    [ROOM_TYPES.Corridor]: DIN_ROOM_TYPES.Flur,
    [ROOM_TYPES.Central]: DIN_ROOM_TYPES.Flur,
    [ROOM_TYPES.Bathroom]: DIN_ROOM_TYPES.Bad,
    [ROOM_TYPES.Toilet]: DIN_ROOM_TYPES.WC,
    [ROOM_TYPES.Garage]: DIN_ROOM_TYPES.KellerBodenraumGarage,
    [ROOM_TYPES.ETC]: DIN_ROOM_TYPES.Flur,
    [ROOM_TYPES.TerraceOrBalcony]: DIN_ROOM_TYPES.Freisitz,
    [ROOM_TYPES.Garden]: DIN_ROOM_TYPES.Freisitz,
};

export let DIN_CONVENTIONAL_COMFORT_TABLES = {
    1: {
        comfortLevel: 1,
        [DIN_ROOM_TYPES.Wohnzimmer]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 6 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 5 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 6 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.SchlafKinderGasteArbeitszimmerBuro]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 5 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.Esszimmer]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kochnische]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kuche]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 5 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hausarbeitsraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Bad]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.WC]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Flur]: [
            {
                maxLength: 3, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                ],
            },
            {
                maxLength: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                ],
            }
        ],
        [DIN_ROOM_TYPES.Freisitz]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Abstellraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.KellerBodenraumGarage]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hobbyraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kellergang]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
    },
    2: {
        comfortLevel: 2,
        [DIN_ROOM_TYPES.Wohnzimmer]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 8 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 6 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 11 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 9 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.SchlafKinderGasteArbeitszimmerBuro]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 8 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 11 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.Esszimmer]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 5 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kochnische]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kuche]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 10 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hausarbeitsraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 8 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Bad]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.WC]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Flur]: [
            {
                maxLength: 3, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                ],
            },
            {
                maxLength: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                ],
            }
        ],
        [DIN_ROOM_TYPES.Freisitz]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Abstellraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.KellerBodenraumGarage]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hobbyraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 6 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kellergang]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
    },
    3: {
        comfortLevel: 3,
        [DIN_ROOM_TYPES.Wohnzimmer]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 10 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 6 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 13 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 9 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.SchlafKinderGasteArbeitszimmerBuro]: [
            {
                maxArea: 20, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 10 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 6 },
                ]
            },
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 13 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 9 },
                ]
            },
        ],
        [DIN_ROOM_TYPES.Esszimmer]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 7 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kochnische]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 4 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kuche]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 12 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurKuhlGefriergerat_7, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurDunstabzug_8, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hausarbeitsraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 10 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },

                ]
            }
        ],
        [DIN_ROOM_TYPES.Bad]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 5 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.WC]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.AnschlusseFurLufter_9, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Flur]: [
            {
                maxLength: 3, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                ],
            },
            {
                maxLength: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 3 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 1 },
                ],
            }
        ],
        [DIN_ROOM_TYPES.Freisitz]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Abstellraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.KellerBodenraumGarage]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Hobbyraum]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 8 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.TelefonDatenanschlusseIuK_3, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurIuK_4, count: 2 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.RadioTVDatenanschlusseRuK_5, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenFurRuK_6, count: 3 },
                ]
            }
        ],
        [DIN_ROOM_TYPES.Kellergang]: [
            {
                maxArea: Infinity, items: [
                    { item: DIN_UPLAN_PRODUCT_MAPPING.SteckdosenAllgemein_1, count: 1 },
                    { item: DIN_UPLAN_PRODUCT_MAPPING.Beleuchtungsanschlusse_2, count: 1 },
                ]
            }
        ],
    },
};